import API from "@fetcher/fetcher";
import type { IResponse } from "@fetcher/models/IResponse";
import { ELoadingOptions } from "@modules/loader/useLoader.hook";
import type { EPaymentMethod } from "@modules/order/models/EPaymentMethod";
import type { ICartItem } from "@modules/order/stores/models/IBasketItem.models";
import dayjs from "dayjs";
import COrderStatus from "../modules/order/models/COrderStatus";
import type Order from "../modules/order/models/IBasket.model";
import type IOrder from "../modules/order/models/IOrder";
import type { IOrderAPI } from "../modules/order/models/IOrder";
import type { IOrderSanitized } from "./models/IOrderSanitized";

const BASE_URL = "/orders";

export class OrderAPI {
  static pay = async (
    items: ICartItem[],
    email: string,
    paymentMethod: EPaymentMethod,
    voucher?: string,
    affiliationCode?: string,
  ) =>
    API.post<Order>(
      `${BASE_URL}`,
      { items, email, voucher, paymentMethod, affiliationCode },
      ELoadingOptions.MODAL,
    );

  static getOrderDetails = async (token: string): Promise<IResponse<IOrder>> =>
    API.get<IOrderAPI>(`${BASE_URL}/${token}`).then(
      (res): IResponse<IOrder> => ({
        ...res,
        data: {
          ...res.data,
          status: new COrderStatus(res.data.status),
          purchasedAt: dayjs(res.data.purchasedAt),
        },
      }),
    );

  static cancelOrder = async (token: string) =>
    API.post<IOrder>(`${BASE_URL}/${token}/cancel`, {}, ELoadingOptions.MODAL);

  static sanitizeCart = (options: {
    items: ICartItem[];
    paymentMethod: EPaymentMethod;
    voucher?: string;
    affiliationCode?: string;
    email?: string;
  }) => API.post<IOrderSanitized>(`${BASE_URL}/sanitize`, options);
}
